"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AllotmentInvoiceList = void 0;
const react_1 = __importDefault(require("react"));
const Table_1 = require("../../Table");
const modificators_1 = require("./modificators");
require("./index.scss");
const className = 'allotment-invoice-list';
const AllotmentInvoiceList = (props) => {
    const { tableColumns, tableData, sorting, setSort, highlightAllotmentInvoiceId, } = props;
    const tableModificators = (0, modificators_1.useTableModificators)(highlightAllotmentInvoiceId);
    return (react_1.default.createElement("div", { className: className },
        react_1.default.createElement(Table_1.Table, { columns: tableColumns, data: tableData, defaultSortBy: sorting.sortBy, defaultSortOrder: sorting.sortOrder, manualSortBy: true, setSort: setSort, tableModificators: tableModificators })));
};
exports.AllotmentInvoiceList = AllotmentInvoiceList;
//# sourceMappingURL=index.js.map